// Utils
import params from "./params";
import MyEmitter from "../helpers/MyEmitter";

const TILTING_MIN = .25
const TILTING_MAX = .45


const silent = true

const Utils = {

    /**
     * API
     */

    fetch: route => {
        return fetch(process.env.VUE_APP_API_ENDPOINT + route)
            .then(res => {
                if(res.ok){
                    return res.json()
                } else {
                    throw res.json()
                }
            })
    },

    async getGalleries() {
        return await Utils.fetch('/galleries')
      },
    
    async getFilms() {
        return await Utils.fetch('/films')
    },

    waitForRessourcesImages: (imgs, then) => {

        if(!imgs.filter(f => f).length){
            console.error("ressources images empty")
            MyEmitter.emit(params.Events.appHasLoadedRessources)
            return
        }

        let loadingImages = imgs.map(src => new Promise((resolve, reject) => {

            if(!silent) console.log("start to load image", src)

            let img = document.createElement("img")
            img.onload = () => {
                if(!silent) console.log("loaded => ", src)
                resolve()
            }
            img.onerror = () => {
                console.log("error => ", src)
                resolve()
            }
            img.src = src

        }))

        Promise.all(loadingImages).then(() => {
            console.log("ALL LAODED <<")
            then &&then()
            MyEmitter.emit(params.Events.appHasLoadedRessources)
        })
    },

    waitForRessourcesVideos: (videos, then) => {

        if(!videos.filter(f => f).length){
            console.error("ressources videos empty")
            MyEmitter.emit(params.Events.appHasLoadedRessources)
            return
        }

        let loadingVideos = videos.map(videosItems => new Promise((resolve, reject) => {
            
            let src = videosItems.src
            let video = videosItems.element || document.createElement("video")

            if(!silent) console.log("start to load video", src)
            
            video.oncanplay = () => {
                if(!silent) console.log("loaded => ", src)
                video.oncanplay = null
                resolve()
            }
            video.onerror = () => {
                console.log("error => ", src)
                video.oncanplay = null
                resolve()
            }
            video.src = src
        }))

        Promise.all(loadingVideos).then(() => {
            console.log("ALL LAODED <<")
            then &&then()
            MyEmitter.emit(params.Events.appHasLoadedRessources)
        })
    },

    /**
     * Objects
     */
    isUndefined: obj => typeof obj === "undefined",
    capitalize(string){
        return string ? string.charAt(0).toUpperCase() + string.slice(1) : ""
    },

    /**
     * Common
     */
    mobileDetected: () => {
        let checkWithUserAgent = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) checkWithUserAgent = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return checkWithUserAgent || window.innerWidth < params.BREAKPOINTS.Desktop
    },

    isSafari: () =>  /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    isInstagram: () =>  /instagram/i.test(navigator.userAgent),

    /**
     * Math
     */

    getLinearFunction({x0, y0}, {x1, y1}){
        let a = (y0 - y1) / (x0 - x1)
        let b = y1 - a * x1

        return x => a * x + b
    },

    randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1) ) + min
    },
    
    limit: (x, min, max) => {
        return x > max ? max : x < min ? min : x
    },

    isBetween: (x, min, max) => x >=min && x <= max,

    lerp: (value1, value2, amount) => (1 - amount) * value1 + amount * value2,

    /**
     * Events
     */

    getMousePosition(event){
        return [
            (event.clientX * 2 - window.innerWidth) / window.innerWidth,
            -(event.clientY * 2 - window.innerHeight) / window.innerHeight
        ]
    },

    /**
     * Cylinders
     */

    getTiltingRotation: (currentMouse, targetMouse, ease) => {

        let y = targetMouse.y
        let x = targetMouse.x

        let nextX = Utils.lerp(currentMouse.x, x, ease)
        let nextY = Utils.lerp(currentMouse.y, y, ease)


        let tiltingX = nextY * .4
        let titlingZ = nextX * -.4 * -nextY

        return {
            nextX, nextY,
            tiltingX, titlingZ,
        }
    },

    getRestrictedTiltingRotation: (currentMouse, targetMouse, ease) => {

        let y = targetMouse.y
        let x = targetMouse.x

        // clamp up
        if(Utils.isBetween(targetMouse.y, 0, TILTING_MIN)){
            y = TILTING_MIN
        }
        // clamp down
        else if(Utils.isBetween(targetMouse.y, -TILTING_MIN, 0)){
            y = -TILTING_MIN
        }

        y = Utils.limit(y, -TILTING_MAX, TILTING_MAX)

        let nextX = Utils.lerp(currentMouse.x, x, ease)
        let nextY = Utils.lerp(currentMouse.y, y, ease)


        let tiltingX = nextY * .85
        let titlingZ = nextX * -.4 * -nextY

        return {
            nextX, nextY,
            tiltingX, titlingZ,
        }
    }


}

export default Utils